import React, { useState, useContext, useEffect, useRef } from "react";
import { Global } from "../../context/globalContextProvider";
import { empty } from "../../utilities/helper";

const AmountInput = ({ name, type, required, disabled = false, uniqueId, onBlurChanged }) => {
  const { donationAmount, setDonationAmount, setShowAddDollarAmount, donationFixedProcessingCost, setShouldCoverDonationProcessingCost } =
    useContext(Global);

  const [active, setActive] = useState(false);
  const [isValidate, setIsValidate] = useState(false); //selection, setSelection
  const amountInput = useRef(donationAmount); //original: textInput (this name doesn't make sense)
  const [inputValue, setInputValue] = useState(donationAmount);
  const [changed, setChanged] = useState(false); //on blur needs to trigger after at least user changed value once

  /**
   *
   * @param {string|null} text
   * @return {string}
   */
  const sanitiseRawInputText = (text) => {
    if (empty(text)) return "";
    if (typeof text !== "string") return text; // if its a number or something else, just return it
    return text
      .replace(/\$/g, "") // Remove dollar signs ($) from the value
      .trim()
      .replace(/[^0-9.]/g, "") // Remove any non-numeric characters except decimal points
      .replace(/(\..*)\./g, "$1"); // and remove multiple decimal points
  };

  useEffect(() => {
    // const inputValue = amountInput.current?.value;
    if (inputValue) {
      // original:
      // let value = amountInput.current?.value.replace(/\$/g, "").trim(); // Remove dollar signs ($) from the value
      // value = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"); // Remove any non-numeric characters except decimal points and remove multiple decimal points
      const value = sanitiseRawInputText(inputValue);

      // original:
      // if (value > 0) {
      //   amountInput.current.dataset.isValidate = true; // Set the "isValidate" attribute to true if the value is greater than 0
      // } else {
      //   amountInput.current.dataset.isValidate = false; // Set the "isValidate" attribute to false if the value is not greater than 0
      // }
      const isValueValid = parseFloat(value) > 0;
      amountInput.current.dataset.isValidate = isValueValid;

      // original:
      // if (amountInput.current.dataset !== undefined) {
      //   setIsValidate(amountInput.current.dataset.isValidate); // Set the "isValidate" state based on the value of the "isValidate" attribute
      // }
      amountInput.current.dataset.isValidate = isValueValid;
      setIsValidate(isValueValid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  const validateInput = (e) => {
    const { id, value } = e.target; // original: const id = e.target.id;

    if (id !== "other-amount") return;
    // original:
    // if (e.target.value === "" || e.target.value === "$" || e.target.value === "$ " || e.target.value === "$  ") {
    //   setShowAddDollarAmount(false);
    // } else {
    //   setShowAddDollarAmount(true);
    // }
    const isEmptyOrDollarSign = ["", "$", "$ ", "$  "].includes(value);
    setShowAddDollarAmount(!isEmptyOrDollarSign);

    //when donationFixedProcessingCost doesn't have value, always reset the checkbox when user input other amount
    if (donationFixedProcessingCost === 0) {
      setShouldCoverDonationProcessingCost(false);
    }

    // original:
    // e.target.value = e.target.value.replace(/\$/g, "").trim();
    // e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    const sanitizedValue = sanitiseRawInputText(value);
    e.target.value = sanitizedValue;
    setDonationAmount(sanitizedValue);

    // original:
    // if (e.target.value > 0) {
    //  e.target.dataset.isValidate = true;
    // } else {
    //  e.target.dataset.isValidate = false;
    // }
    e.target.dataset.isValidate = sanitizedValue > 0;
  };

  if (uniqueId === "other-amount") {
    return (
      <div className="donation_field other-amount">
        <input
          data-ispristine="true"
          onChange={(event) => {
            setChanged(true);
            setInputValue(event.target.value);
            validateInput(event);
          }}
          onBlur={(event) => {
            if (onBlurChanged && changed) {
              onBlurChanged(event);
            }
          }}
          // original: onChangeCapture={activeBorder}
          // do not need to define another function, just do it inline
          onChangeCapture={() => setActive(true)}
          name={name}
          type={type}
          placeholder={`${name}${required ? " (required)" : ""}`}
          disabled={disabled}
          value={"$" + donationAmount}
          className={active ? "active_amount" : ""}
          id={uniqueId}
          ref={amountInput}
        />
        <label className={active ? "active_amount_label" : ""} alt={name} htmlFor={uniqueId} placeholder={`${name}${required ? "*" : ""}`}>{`${name}${
          required ? " (required)" : ""
        }`}</label>
        {isValidate === "false" && <div className="validation-msg">Please enter amount</div>}
        {!isNaN(donationAmount) && donationAmount < 2 ? <div className="validation-msg">The minimum donation amount is $2.</div> : null}
      </div>
    );
  }

  console.error("Amount Input only supports field with unique id of 'other-amount' at the moment.");
  return null;
};

export default AmountInput;
